import { Dispatch, SetStateAction } from "react";
import "./HeaderComponent.css";
import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Searchbar from "../Searchbar/Searchbar";
import { TimePeriodPicker } from "../TimePeriodPicker/TimePeriodPicker";

interface BaseProps {
  pageTitle: string;
  hasTimePeriodPicker?: boolean;
  backDestination: string;
}

interface WithSearchBar extends BaseProps {
  hasSearchBar: true;
  searchInput: string;
  setSearchInput: Dispatch<SetStateAction<string>>;
  entityToSearch: string;
}

interface WithoutSearchBar extends BaseProps {
  hasSearchBar?: false;
  searchInput?: never;
  setSearchInput?: never;
  entityToSearch?: never;
}

interface FinanceProps {
  isFinance: true;
  notificationButtonText?: string;
  onToggleNotifications: () => void;
  onSendReminderToProjectManagers: () => void;
}

interface NonFinanceProps {
  isFinance?: false;
  notificationButtonText?: never;
  onToggleNotifications?: never;
  onSendReminderToProjectManagers?: never;
}

type Props =
  | ((WithSearchBar | WithoutSearchBar) & FinanceProps)
  | ((WithSearchBar | WithoutSearchBar) & NonFinanceProps);

function HeaderComponent({
  pageTitle,
  hasSearchBar = false,
  setSearchInput,
  searchInput,
  entityToSearch,
  hasTimePeriodPicker = false,
  backDestination,
  isFinance = false,
  notificationButtonText,
  onToggleNotifications,
  onSendReminderToProjectManagers,
}: Props) {
  return (
    <div className="header">
      <div className="header-left">
        <span className="back">
          <Link to={backDestination}>
            <ChevronLeft size={30} color="white" />
          </Link>
        </span>

        <h2 className="header-page-title">{pageTitle}</h2>
      </div>

      <div className="header-right">
        {hasTimePeriodPicker && (
          <div className="timeperiod-picker-container">
            <TimePeriodPicker />
          </div>
        )}

        {hasSearchBar && searchInput !== undefined && (
          <div className="searchbar-container">
            <Searchbar
              searchInput={searchInput}
              setSearchInput={setSearchInput}
              entityToSearch={entityToSearch}
            />
          </div>
        )}

        {isFinance && (
          <div className="finance-buttons">
            <button className="finance-button" onClick={onToggleNotifications}>
              {notificationButtonText || "Benachrichtigungen toggeln"}
            </button>

            <button className="finance-button" onClick={onSendReminderToProjectManagers}>
              PLs auffordern
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default HeaderComponent;
